import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { loginGoogle } from '@adex/store/actions/auth.actions'
import { IGoogleLoginData } from '../../models/google-auth.model'

@Component({
  selector: 'adex-google-auth',
  templateUrl: './google-auth.component.html',
  styleUrls: ['./google-auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleAuthComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private readonly store: Store, private router: Router) { }

  public ngOnInit(): void {
    const data: IGoogleLoginData = {
      code: this.activatedRoute.snapshot.queryParamMap.get('code'),
      uri: `${window.location.origin}/auth/google`
    }

    const userFromQueryParams = window.localStorage.getItem('adex|userFromQueryParams')

    if (userFromQueryParams?.length > 0) {
      window.localStorage.removeItem('adex|userFromQueryParams')

      this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: { user: userFromQueryParams },
          queryParamsHandling: 'merge'
        }).then(() => {
        this.store.dispatch(loginGoogle({ data }))
      })
    } else {
      this.store.dispatch(loginGoogle({ data }))
    }
  }
}
